// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import validarCpf from "validar-cpf";

function isValid(cpf) {
  return validarCpf(cpf);
}

function format(cpf) {
  const unformattedCpf = cpf.replace(/\D/g, "");

  const regex = /^(\d{3})(\d{3})(\d{3})(\d{2})$/;
  const mask = "$1.$2.$3-$4";

  return unformattedCpf.replace(regex, mask);
}

const cpfUtils = {
  isValid,
  format,
};

export default cpfUtils;
